module.exports = __webpack_public_path__ + "static/media/blr.019cc0a3.svg";